<div class="tc-leaderboard__container">
  <div
    *ngIf="
      teams?.length > 0 &&
      ((!isPastChallenge && teamUser?.membershipStatus !== TeamMembershipStatus.MEMBER) ||
        (challenge?.minimalTeamMembers && team && team.userGroups.members.length < challenge?.minimalTeamMembers))
    "
    class="tc-leaderboard__error-container"
  >
    <p class="tc-leaderboard__error-heading">{{ 'STATS.CHALLENGE_LEADERBOARD.notParticipatingText' | translate }}</p>
    <p *ngIf="originalTeamUser?.membershipStatus === TeamMembershipStatus.APPLICATION" class="tc-leaderboard__error-message">
      {{ 'STATS.CHALLENGE_LEADERBOARD.noMembershipApplication' | translate }}
    </p>
    <p *ngIf="originalTeamUser?.membershipStatus === TeamMembershipStatus.INVITATION" class="tc-leaderboard__error-message">
      {{ 'STATS.CHALLENGE_LEADERBOARD.noMembershipInvitation' | translate }}
    </p>
    <p *ngIf="teamHasNotEnoughMembers" class="tc-leaderboard__error-message">
      {{ 'STATS.CHALLENGE_LEADERBOARD.noMembershipMinimumMembers' | translate }}
    </p>
    <p
      *ngIf="!teamHasNotEnoughMembers && (originalTeamUser?.membershipStatus === TeamMembershipStatus.NONE || !originalTeamUser)"
      class="tc-leaderboard__error-message"
    >
      {{ 'STATS.CHALLENGE_LEADERBOARD.noMembership' | translate }}
    </p>
  </div>

  <!-- If no teams exist -> show error -->
  <div *ngIf="teams?.length === 0" class="tc-leaderboard__error-container">
    <p class="tc-leaderboard__error-heading">{{ 'STATS.CHALLENGE_LEADERBOARD.noTeamsHeading' | translate }}</p>
    <p class="tc-leaderboard__error-message">
      {{ 'STATS.CHALLENGE_LEADERBOARD.noTeamsDescription' | translate }}
    </p>
  </div>

  <div *ngIf="isPastChallenge && challengeWinnerTeams?.first" class="tc-leaderboard__challenge-result">
    <div class="tc-leaderboard__challenge-result-container tc-leaderboard__challenge-result-container--teams">
      <p class="tc-leaderboard__challenge-result-heading">{{ 'STATS.CHALLENGE_LEADERBOARD.winnerTeamsHeading' | translate }}</p>
      <div class="tc-leaderboard__challenge-result-team-container">
        <p *ngIf="challengeWinnerTeams?.first" class="tc-leaderboard__challenge-result-team">
          <img class="tc-leaderboard__challenge-result-team-icon" src="assets/icons/general/medal-gold.png" />1.
          {{ 'STATS.CHALLENGE_LEADERBOARD.place' | translate }}:
          {{ challengeWinnerTeams.first.name }}
        </p>
        <p *ngIf="challengeWinnerTeams?.second" class="tc-leaderboard__challenge-result-team">
          <img class="tc-leaderboard__challenge-result-team-icon" src="assets/icons/general/medal-silver.png" />2.
          {{ 'STATS.CHALLENGE_LEADERBOARD.place' | translate }}:
          {{ challengeWinnerTeams.second.name }}
        </p>
        <p *ngIf="challengeWinnerTeams?.third" class="tc-leaderboard__challenge-result-team">
          <img class="tc-leaderboard__challenge-result-team-icon" src="assets/icons/general/medal-bronze.png" />3.
          {{ 'STATS.CHALLENGE_LEADERBOARD.place' | translate }}:
          {{ challengeWinnerTeams.third.name }}
        </p>
      </div>
    </div>
    <div
      *ngIf="challenge?.rewardsText"
      class="tc-leaderboard__challenge-result-container tc-leaderboard__challenge-result-container--rewards"
    >
      <p class="tc-leaderboard__challenge-result-heading">{{ 'STATS.CHALLENGE_LEADERBOARD.rewards' | translate }}</p>
      <textarea rows="20" class="tc-leaderboard__challenge-result-rewards" disabled>{{ challenge?.rewardsText }}</textarea>
    </div>
  </div>

  <!-- Score of user team is only displayed if user is member of the team (not if status is application or invitation)-->
  <div
    *ngIf="
      teamUser?.membershipStatus === TeamMembershipStatus.MEMBER &&
      (!challenge?.minimalTeamMembers || (team && team.userGroups.members.length >= challenge?.minimalTeamMembers))
    "
    class="tc-leaderboard__inner-container"
  >
    <div class="tc-leaderboard__header-section">
      <div class="tc-leaderboard__header-section-heading">
        {{ 'STATS.CHALLENGE_LEADERBOARD.myTeam' | translate }}
      </div>
    </div>

    <app-chips-list-notResponsive class="tc-leaderboard__displayMode">
      <app-chip-notResponsive
        class="tc-leaderboard__displayMode-choice"
        [ngClass]="{
          'tc-leaderboard__displayMode-choice--selected': showWeeklyUserScore
        }"
        (select)="setShowWeeklyUserScore(true)"
        [selected]="showWeeklyUserScore"
      >
        {{ 'STATS.CHALLENGE_LEADERBOARD.weekly' | translate }}
      </app-chip-notResponsive>
      <app-chip-notResponsive
        class="tc-leaderboard__displayMode-choice"
        [ngClass]="{
          'tc-leaderboard__displayMode-choice--selected': !showWeeklyUserScore
        }"
        (select)="setShowWeeklyUserScore(false)"
        [selected]="!showWeeklyUserScore"
      >
        {{ 'STATS.CHALLENGE_LEADERBOARD.total' | translate }}
      </app-chip-notResponsive>
    </app-chips-list-notResponsive>

    <div class="tc-leaderboard__filter" *ngIf="showWeeklyUserScore">
      <div
        class="tc-leaderboard__filter-button"
        [ngClass]="{
          'tc-leaderboard__filter-button--hidden': selectedUserWeek === 0
        }"
        (click)="setSelectedWeek(selectedUserWeek - 1, 'users')"
      >
        <img src="assets/icons/general/arrow-left.svg" class="tc-leaderboard__filter-button-icon" />
      </div>

      <span class="tc-leaderboard__filter-selection"> {{ 'STATS.CHALLENGE_LEADERBOARD.week' | translate }} {{ selectedUserWeek + 1 }}</span>
      <div
        class="tc-leaderboard__filter-button"
        [ngClass]="{
          'tc-leaderboard__filter-button--hidden': selectedUserWeek === maxWeek
        }"
        (click)="setSelectedWeek(selectedUserWeek + 1, 'users')"
      >
        <img src="assets/icons/general/arrow-right.svg" class="tc-leaderboard__filter-button-icon" />
      </div>
    </div>

    <div class="tc-leaderboard__table-container">
      <div class="tc-leaderboard__table-header">
        <span class="tc-leaderboard__table-entry-position"> {{ 'STATS.CHALLENGE_LEADERBOARD.position' | translate }} </span>
        <span class="tc-leaderboard__table-entry-name"> {{ 'STATS.CHALLENGE_LEADERBOARD.teamMembers' | translate }} </span>
        <span class="tc-leaderboard__table-entry-points"> {{ 'STATS.CHALLENGE_LEADERBOARD.points' | translate }} </span>
      </div>
      <!-- Users are viewchildren, set userid data attribute in order to be able to find out to which user should be scrolled -->
      <div
        #userElem
        *ngFor="let user of team?.userGroups.members; let i = index"
        [attr.data-userid]="user?._id"
        class="tc-leaderboard__table-entry"
        [ngClass]="{ 'tc-leaderboard__table-entry--highlight': currentUser._id === user?._id }"
      >
        <span class="tc-leaderboard__table-entry-position">{{ i + 1 }} </span>
        <span title="{{ user?.email }}" class="tc-leaderboard__table-entry-name">
          {{ user?.alias ? user.alias : user?.firstName + ' ' + user?.lastName }}
          <img
            *ngIf="currentUser._id === user?._id"
            src="assets/icons/general/person.svg"
            title="{{ 'CHALLENGE.thatsMe' | translate }}"
            class="tc-leaderboard__table-entry-icon"
          />
          <img
            *ngIf="currentUser._id !== user?._id && !isPastChallenge"
            src="assets/icons/general/megaphone.png"
            title="{{ 'STATS.CHALLENGE_LEADERBOARD.cheerForTeamMemberTooltip' | translate }}"
            class="tc-leaderboard__table-entry-icon--large"
            (click)="cheerForTeamMemberDebounced(user?.firstName + ' ' + user?.lastName, user?._id)"
          />
        </span>
        <img
          *ngIf="user.bonuses.salmagundi.completionDay"
          title="{{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.salmagundiTooltip' | translate }}"
          class="tc-leaderboard__table-entry-bonus-icon"
          src="assets/icons/general/allrounder.png"
        />
        <span class="tc-leaderboard__table-entry-points">
          {{ showWeeklyUserScore ? user.points?.byWeek[selectedUserWeek] || 0 : user.points?.total || 0 }}
        </span>
      </div>
    </div>
  </div>

  <!-- Team leaderboard (Do not display this if no team takes part in challenge)-->
  <div class="tc-leaderboard__inner-container" *ngIf="teams?.length > 0">
    <div class="tc-leaderboard__header-section">
      <div class="tc-leaderboard__header-section-heading tc-leaderboard__header-section-heading--team">
        {{ 'STATS.CHALLENGE_LEADERBOARD.teamRating' | translate }}
      </div>
    </div>

    <app-chips-list-notResponsive class="tc-leaderboard__displayMode">
      <app-chip-notResponsive
        class="tc-leaderboard__displayMode-choice"
        [ngClass]="{
          'tc-leaderboard__displayMode-choice--selected': showWeeklyTeamScore
        }"
        (select)="setShowWeeklyTeamScore(true)"
        [selected]="showWeeklyTeamScore"
      >
        {{ 'STATS.CHALLENGE_LEADERBOARD.weekly' | translate }}
      </app-chip-notResponsive>
      <app-chip-notResponsive
        class="tc-leaderboard__displayMode-choice"
        [ngClass]="{
          'tc-leaderboard__displayMode-choice--selected': !showWeeklyTeamScore
        }"
        (select)="setShowWeeklyTeamScore(false)"
        [selected]="!showWeeklyTeamScore"
      >
        {{ 'STATS.CHALLENGE_LEADERBOARD.total' | translate }}
      </app-chip-notResponsive>
    </app-chips-list-notResponsive>

    <div class="tc-leaderboard__filter" *ngIf="showWeeklyTeamScore">
      <div
        class="tc-leaderboard__filter-button"
        [ngClass]="{
          'tc-leaderboard__filter-button--hidden': selectedTeamWeek === 0
        }"
        (click)="setSelectedWeek(selectedTeamWeek - 1, 'teams')"
      >
        <img src="assets/icons/general/arrow-left.svg" class="tc-leaderboard__filter-button-icon" />
      </div>

      <span class="tc-leaderboard__filter-selection"> {{ 'STATS.CHALLENGE_LEADERBOARD.week' | translate }} {{ selectedTeamWeek + 1 }}</span>

      <div
        class="tc-leaderboard__filter-button"
        [ngClass]="{
          'tc-leaderboard__filter-button--hidden': selectedTeamWeek === maxWeek
        }"
        (click)="setSelectedWeek(selectedTeamWeek + 1, 'teams')"
      >
        <img src="assets/icons/general/arrow-right.svg" class="tc-leaderboard__filter-button-icon" />
      </div>
    </div>

    <div class="tc-leaderboard__table-container">
      <div class="tc-leaderboard__table-header">
        <span class="tc-leaderboard__table-entry-position"> {{ 'STATS.CHALLENGE_LEADERBOARD.position' | translate }} </span>
        <span class="tc-leaderboard__table-entry-name"> {{ 'STATS.CHALLENGE_LEADERBOARD.teamName' | translate }} </span>
        <span class="tc-leaderboard__table-entry-points" title="{{ 'STATS.CHALLENGE_LEADERBOARD.teamPointsDescription' | translate }}">
          {{ 'STATS.CHALLENGE_LEADERBOARD.points' | translate }}
          <img
            src="assets/icons/general/info-circle-orange.svg"
            class="tc-leaderboard__table-entry-points-icon"
          />
        </span>
      </div>
      <!-- Teams are viewchildren, set userid data attribute in order to be able to find out to which team should be scrolled -->
      <div
        #teamElem
        *ngFor="let currentTeam of teams; let i = index"
        [attr.data-teamid]="currentTeam?._id"
        class="tc-leaderboard__table-entry"
        [ngClass]="{ 'tc-leaderboard__table-entry--highlight': team?._id === currentTeam?._id }"
      >
        <span class="tc-leaderboard__table-entry-position">{{ i + 1 }} </span>
        <span class="tc-leaderboard__table-entry-name">
          {{ currentTeam.name }}
          <img
            *ngIf="team?._id === currentTeam._id"
            src="assets/icons/general/person.svg"
            title="{{ 'STATS.CHALLENGE_LEADERBOARD.thatsMyTeam' | translate }}"
            class="tc-leaderboard__table-entry-icon"
          />
        </span>
        <img
          *ngIf="showWeeklyTeamScore && weeklyWinners[selectedTeamWeek] === currentTeam._id"
          class="tc-leaderboard__table-entry-bonus-icon"
          title="{{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.weeklyWinnerTooltip' | translate }}"
          src="assets/icons/general/pokal.png"
        />
        <span class="tc-leaderboard__table-entry-points">
          {{ showWeeklyTeamScore ? currentTeam.points?.byWeek[selectedTeamWeek] || 0 : currentTeam.points?.total || 0 }}
        </span>
      </div>
    </div>
  </div>

  <!-- Bonus section is only displayed if user is member of the team (not if status is application or invitation)-->
  <app-challenge-leaderboard-bonus
    *ngIf="
      !isPastChallenge &&
      teamUser?.membershipStatus === TeamMembershipStatus.MEMBER &&
      (!challenge?.minimalTeamMembers || (team && team.userGroups.members.length >= challenge?.minimalTeamMembers))
    "
    [challenge]="challenge"
    [currentUser]="currentUser"
    [currentChallengeDay]="currentChallengeDay"
    [teamUser]="teamUser"
  >
  </app-challenge-leaderboard-bonus>

  <div *ngIf="teams" class="tc-leaderboard__info-button-container">
    <button class="tc-leaderboard__info-button" type="button" color="primary" (click)="openChallengeTutorial()" mat-raised-button>
      {{ 'STATS.CHALLENGE_LEADERBOARD.infoButton' | translate }}
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/challenge-statistics/components/challenge-leaderboard/challenge-leaderboard.component.html